import React, { useEffect } from "react";

// Modules
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Components
import ScrollToTop from "Component/ScrollToTop";
// Themes
import Hometheme from "../themes/home-theme";
import Museumregister from "../themes/museum-register";
import Communitytheme from "../themes/community-theme";
import Faqtheme from "../themes/faq-theme ";
import Privacytheme from "../themes/privacy-theme";
import Termstheme from "../themes/terms-theme";
import Profiletheme from "../themes/profile-theme";
import Collectiontheme from "../themes/collection-theme";
import Cardprofiletheme from "../themes/card-profile";
import Reporttheme from "../themes/report-theme";
import Biddingtheme from "../themes/bidding-theme";
import Artisttheme from "../themes/artist-theme";
import Profilereviewtheme from "../themes/profilereview-theme";
import Paymentmethodtheme from "../themes/paymentmethod-theme";
import Signmetamasktheme from "../themes/signmetamask-theme";
import Createnfttheme from "themes/createnft-theme";
import Logintheme from "themes/login-theme";

import BlogDetailTheme from "./blogdetail-theme";
import AboutTheme from "themes/aboutTheme";
import ExploreTheme from "themes/explore-theme";
import TopCollectionCommunity from "themes/communityTheme";
import Artistfaqtheme from "themes/artistfaq-theme";
import ForgotPassTheme from "themes/forgot-theme";
import CommingSoonPage from "Pages/CommingSoonPage";

// 404 Page
import Page404 from "./page404";

// Actions
import { getCurrentUser, getSettings } from "store/actions";
import ProfileHome from "Pages/Profile/Home";
import VerifyEmail from "helpers/VerifyEmail";
import VerifiedEmail from "helpers/VerifiedEmail";

import ProfileCollection from "Pages/Profile/Collection";
import CreateCollection from "Pages/CreateCollection/CreateCollection";
import SoldbyArtist from "Pages/Profile/SoldbyArtist";
import NftCreate from "Pages/Profile/nft";
import UpcomingNft from "Pages/Profile/UpcomingNft";
import CollectedNft from "Pages/Profile/CollectedNft";
import Editprofile from "Pages/Editprofile/Editprofile";
import PassWordStatus from "Pages/ForgotPassword/PasswordStatus";
import Art from "Pages/Profile/art";
import ViewCollection from "Pages/CreateCollection/ViewCollection";
import Category from "Pages/category/Category";

import MuseumsView from "Component/TopMuseum/museumsview";
import SearchResult from "Component/SearchResult/SearchResult";

import Blogs from "Pages/blogs/Blogs";
import LiveActionNft from "Pages/SaleNft/LiveAuctionNFT";
import NftSale from "Pages/SaleNft/NftSale";
import Physical_Artwork_sale from "Pages/SaleNft/Physical_Artwork_sale";
import OwnedNft from "Pages/Profile/OwnedNft";
import ViewOwnedNft from "Pages/Profile/ViewOwnedNft";
import ArtistView from "Component/TrandingArtist/ArtistView";
import AuctionView from "Component/AuctionCard/AuctionView";
import ArtistViewAll from "Component/TrandingArtist/ArtistViewAll";
import Earnings from "Pages/Profile/Earnings";
import ArtGenre from "themes/ArtGenre";
import Setting from "Pages/Profile/Setting";

import HomeDashboard from "Pages/Profile/HomeDashboard";
import NftView from "Component/nft/NftView";
import CollectionView from "Component/TopMuseum/CollectionView";
import Share from "Component/Share/Share";
import NFTPurchaseAndIPLicense_Agreement from "themes/nft-purchase_and_IP_license_agreement";
import ReferredComponent from "Pages/Refeerred/ReferredComponent";
import NewsLetterVerify from "helpers/NewsLetterVerify";
import UploadArt from "Pages/Profile/UploadArt";
import PrintRequest from "Pages/Profile/PrintRequest";
import Printoption from "Component/Printoptionpage/Printoption";
import WithdrawFiat from "Pages/Profile/WithdrawalFiet";
import TopCollectionCustomArt from "themes/custom-art-theme";
import CustomArtRequest from "Pages/Profile/CustomArtRequest";
import CustomArtRequestView from "Pages/CreateArtRequestView/createArtRequestView";
import Createnftthemedigital from "themes/createnft-theme-digital";
import Createnftthemephysical from "themes/createnft-theme-physical";
import NftSalePhysical from "Pages/SaleNft/NftSalePhysical";
// import CheckoutForm from "Component/CheckoutComponent/CheckoutForm";
// import Test from "Component/Test";

const MyRouts = () => {
  let dispatch = useDispatch();
  let authToken = localStorage.getItem("authToken");
  const getWalletAddress = localStorage.getItem("walletAddress");
  const { user } = useSelector((state) => state?.Login);
  const { settings } = useSelector((state) => state?.Login);

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  useEffect(() => {
    if (!!authToken) {
      dispatch(getCurrentUser());
    }
  }, [authToken]);
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {settings?.isCommingSoon === false ? (
            <>
              <Route exact path="/" element={<CommingSoonPage />} />
            </>
          ) : (
            <>
              <Route exact path="*" element={<Page404 />} />

              <Route exact path="/" element={<Hometheme />} />
              <Route exact path="/print-option" element={<Printoption />} />
              <Route
                exact
                path="/referred-route/:id"
                element={<ReferredComponent />}
              />
              <Route exact path="/art-genres" element={<SearchResult />} />
              <Route
                exact
                path="/custom-art"
                element={<TopCollectionCustomArt />}
              />

              <Route exact path="/auction-view" element={<AuctionView />} />
              <Route exact path="/artist-view" element={<ArtistViewAll />} />
              <Route
                exact
                path="/collection-view/:id"
                element={<CollectionView />}
              />
              <Route exact path="/share" element={<Share />} />
              <Route exact path="/category" element={<Category />} />
              <Route exact path="/museums" element={<MuseumsView />} />
              <Route
                exact
                path="/liveAuctionNft/:id"
                element={<LiveActionNft />}
              />
              <Route exact path="/nftsale/:id" element={<NftSale />} />
              <Route
                exact
                path="/nftsale/physical/:id"
                element={<NftSalePhysical />}
              />

              <Route
                exact
                path="/Physical_Artwork"
                element={<Physical_Artwork_sale />}
              />
              <Route exact path="view-profile/:id" element={<ArtistView />} />
              <Route
                exact
                path="view-profile/auctionId/:id"
                element={<ArtistView />}
              />
              <Route
                exact
                path="view-profile/artist/:id"
                element={<ArtistView />}
              />
              <Route exact path="nfts/:id" element={<NftView />} />
              <Route exact path="/blogs" element={<Blogs />} />
              <Route
                exact
                path="blogs/blog-detail"
                element={<BlogDetailTheme />}
              />
              <Route exact path="/shop" element={<ExploreTheme />} />
              <Route exact path="/user-faq" element={<Faqtheme />} />
              <Route exact path="/artist-faq" element={<Artistfaqtheme />} />
              <Route exact path="/news-letter" element={<Reporttheme />} />
              <Route exact path="/faq" element={<CommingSoonPage />} />
              <Route exact path="/art-genres" element={<ArtGenre />} />
              <Route exact path="/privacy-policy" element={<Privacytheme />} />
              <Route exact path="/terms" element={<Termstheme />} />
              <Route
                exact
                path="/nft-purchase_and_IP_license_agreement"
                element={<NFTPurchaseAndIPLicense_Agreement />}
              />
              <Route exact path="/about" element={<AboutTheme />} />
              <Route
                exact
                path="/card-profile"
                element={<Cardprofiletheme />}
              />

              <Route exact path="/bidding" element={<Biddingtheme />} />
              <Route
                exact
                path="/sell/:resellId"
                element={<Createnfttheme />}
              />

              <Route
                exact
                path="/community"
                element={<TopCollectionCommunity />}
              />
              <Route
                exact
                path="/forgot-password"
                element={<ForgotPassTheme />}
              />
              <Route exact path="success" element={<PassWordStatus />}></Route>
              <Route
                exact
                path="/profile-review"
                element={<Profilereviewtheme />}
              />
              <Route
                exact
                path="/payment-method"
                element={<Paymentmethodtheme />}
              />
              <Route
                exact
                path="/metamask-sign"
                element={<Signmetamasktheme />}
              />
              <Route exact path="/verifiedEmail" element={<VerifiedEmail />} />

              <Route
                exact
                path="/verifiedEmail/:token"
                element={<VerifiedEmail />}
              />
              <Route
                exact
                path="/newLetterVerifiedEmail/:token"
                element={<NewsLetterVerify />}
              />
              {user?.role !== "USER" &&
                user?.verificationProfileStatus == "accept" && (
                  <>
                    {authToken && (
                      <>
                        <Route
                          exact
                          path="/collections"
                          element={<Collectiontheme />}
                        />
                        {getWalletAddress && (
                          <Route
                            exact
                            path="/create"
                            element={<Createnfttheme />}
                          />
                        )}
                        <Route
                          exact
                          path="/item/:itemId"
                          element={<Createnfttheme />}
                        />
                      </>
                    )}
                  </>
                )}

              {!authToken ? (
                <>
                  <Route exact path="/login" element={<Logintheme />} />
                  <Route
                    exact
                    path="/artist/register"
                    element={<Artisttheme />}
                  />
                  <Route
                    exact
                    path="/museums/register"
                    element={<Museumregister />}
                  />
                  <Route
                    exact
                    path="/users/register"
                    element={<Communitytheme />}
                  />

                  <Route exact path="/verifyEmail" element={<VerifyEmail />} />

                  {/* <Route exact path="/verifiedemail" element={<VerifiedEmail />} /> */}
                </>
              ) : (
                <>
                  <Route exact path="/login" element={<Navigate to="/" />} />
                  <Route path="/users/register" element={<Navigate to="/" />} />
                  <Route path="/profile" element={<Profiletheme />}>
                    <Route
                      path="CreateArtRequestView/createArtRequestView"
                      element={<CustomArtRequestView />}
                    />
                    <Route
                      exact
                      path="view-profile"
                      element={<Editprofile />}
                    />
                    {/* <Route path="home" element={<HomeDashboard />} />
                    <Route path="earnings" element={<Earnings />} /> */}
                    <Route path="home" element={<Earnings />} />
                    <Route
                      path="customArtRequest"
                      element={<CustomArtRequest />}
                    />
                    <Route path="withdrawal-fiet" element={<WithdrawFiat />} />

                    <Route path="reviews" element={<ProfileHome />} />
                    <Route path="settings" element={<Setting />} />
                    <Route
                      path="collection/created"
                      element={<ProfileCollection data={"collection"} />}
                    />

                    <Route path="printrequest" element={<PrintRequest />} />

                    <Route path="art" element={<Art />} />
                    <Route
                      path="artworkproofing"
                      element={<Art data={"artworkproofing"} />}
                    />

                    <Route path="art/uploadArt" element={<UploadArt />} />
                    <Route
                      path="artworkproofing/uploadArt"
                      element={<UploadArt data={"printablefield"} />}
                    />

                    <Route
                      path="ownedNft"
                      element={<OwnedNft data={"ownedNft"} />}
                    />
                    <Route
                      path="ownedNft/viewNft/:id"
                      element={<ViewOwnedNft data={"ownedNft"} />}
                    />
                    <Route path="nft/viewNft/:id" element={<ViewOwnedNft />} />
                    <Route
                      path="collection/viewNft/:id"
                      element={<ViewOwnedNft />}
                    />

                    <Route
                      path="collection/soldbyartist"
                      element={<SoldbyArtist />}
                    />
                    <Route path="nft/soldbyartist" element={<SoldbyArtist />} />
                    <Route path="nft/upcomingnft" element={<UpcomingNft />} />
                    <Route path="nft/collected" element={<CollectedNft />} />

                    <Route
                      path="nft/created"
                      element={<NftCreate data={"nft"} />}
                    />
                    <Route
                      path="collection/createcollection"
                      element={<CreateCollection />}
                    />
                    <Route
                      path="collection/createcollection/:id"
                      element={<CreateCollection />}
                    />
                    <Route
                      path="collection/viewcollection/:id"
                      element={<ViewCollection />}
                    />

                    {/* <Route exact path="nft/createnft" element={<Createnfttheme />} /> */}
                    <Route
                      exact
                      path="nft/create-digital-nft"
                      element={<Createnftthemedigital />}
                    />
                    <Route
                      exact
                      path="nft/create-physical-nft"
                      element={<Createnftthemephysical />}
                    />

                    <Route
                      exact
                      path="nft/createnft"
                      element={<Createnfttheme />}
                    />
                    <Route
                      exact
                      path="nft/editnft"
                      element={<Createnfttheme />}
                    />
                    <Route
                      exact
                      path="ownedNft/editnft"
                      element={<Createnfttheme />}
                    />
                  </Route>
                </>
              )}
              <Route exact path="*" element={<Hometheme />} />
              {/* <Route exact path="profile/:artnew" element={<Artuploadnew />} /> */}
            </>
          )}
        </Routes>
      </BrowserRouter>
    </div>
  );
};
export default MyRouts;
